var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GroupSingleText',{key:_vm.fieldId,attrs:{"field-id":_vm.fieldId,"field-namespace":_vm.fieldNamespace}})
}
var staticRenderFns = []

export { render, staticRenderFns }